<div class="showcase-item">
    <img src="../assets/photos/showcase/{{slide.imgStr}}">
    <p>{{slide.text}}</p> 
</div>
